<template>
  <div :style="containerStyle">
    <div :style="headerContainerStyle">
      <HeaderLargeLight>
        User Management
      </HeaderLargeLight>
      <ButtonPrimary @click="openModalToInviteUsers">
        Invite people
      </ButtonPrimary>
    </div>
    <TabPrimary v-model="selectedTabIndex"
                :style="tabStyle"
                :tabs="tabs" />
    <template v-if="selectedTabIndex === 0">
      <AdminUsersUsers />
    </template>
    <template v-else-if="selectedTabIndex === 1">
      <AdminUsersPendingInvitations />
    </template>
  </div>
</template>

<script>
  import AdminUsersPendingInvitations from '@settings/modules/admin-users-pending-invitations'
  import AdminUsersUsers from '@settings/modules/admin-users-users'
  import ButtonPrimary from '@modules/button/button-primary'
  import HeaderLargeLight from '@modules/text/header-large-light'
  import TabPrimary from '@modules/tab/tab-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'AdminUsersView',
    components: {
      AdminUsersPendingInvitations,
      AdminUsersUsers,
      ButtonPrimary,
      HeaderLargeLight,
      TabPrimary,
    },
    data: function () {
      return {
        cardStyle: {
          marginTop: Layout.space.lg,
          padding: Layout.space.lg,
        },
        containerStyle: {
          maxWidth: '100%',
          width: '100%',
        },
        headerContainerStyle: {
          alignItems: 'flex-start',
          display: 'flex',
          justifyContent: 'space-between',
        },
        selectedTabIndex: 0,
        tabs: [
          { label: 'Users' },
          { label: 'Pending Invitations' },
        ],
        tabStyle: {
          marginTop: '36px',
        },
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      ...mapState({
        tenant: state => state.tenant,
      }),
    },
    methods: {
      openModalToInviteUsers: function () {
        const params = {
          tenant: this.tenant,
        };
        this.$modal.show(MODAL_WINDOW_NAMES.INVITE_TO_TENANT_PRIMARY, params);
      },
    },
  };
</script>
